import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t, setUser } = useApp();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token: params.get("token"), password: pw });
      localStorage.setItem("gg_token", data.token); setUser(data.user);
      toast.success(t("passwordUpdated")); nav("/");
    } catch (err) { toast.error(err.response?.status === 400 ? t("resetFailed") : "Failed"); }
    setBusy(false);
  };
  return (
    <div className="max-w-md mx-auto px-4 py-10">
      <form onSubmit={submit} className="gg-card p-6 flex flex-col gap-3" data-testid="reset-password-form">
        <h1 className="font-display uppercase text-3xl tracking-tighter">{t("setNewPassword")}</h1>
        <label className="eyebrow">{t("newPassword")}</label>
        <input required type="password" minLength={12} className="gg-input" value={pw} onChange={e => setPw(e.target.value)} data-testid="reset-password-input" />
        <button disabled={busy} className="gg-btn-primary mt-2" data-testid="reset-password-submit">{t("setNewPassword")}</button>
        <Link to="/auth" className="eyebrow underline text-center mt-2">{t("backToLogin")}</Link>
      </form>
    </div>
  );
}
